/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Task_Status_LabelInputs */

const en_task_status_label = /** @type {(inputs: Task_Status_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.status === "todo") return /** @type {LocalizedString} */ (`To do`);
	if (i?.status === "in_progress") return /** @type {LocalizedString} */ (`In progress`);
	if (i?.status === "waiting") return /** @type {LocalizedString} */ (`Waiting`);
	if (i?.status === "done") return /** @type {LocalizedString} */ (`Done`);
	if (i?.status === "canceled") return /** @type {LocalizedString} */ (`Canceled`);
	return /** @type {LocalizedString} */ (`${i?.status}`)
	
};

const pt_br2_task_status_label = /** @type {(inputs: Task_Status_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.status === "todo") return /** @type {LocalizedString} */ (`A fazer`);
	if (i?.status === "in_progress") return /** @type {LocalizedString} */ (`Em andamento`);
	if (i?.status === "waiting") return /** @type {LocalizedString} */ (`Aguardando`);
	if (i?.status === "done") return /** @type {LocalizedString} */ (`Concluído`);
	if (i?.status === "canceled") return /** @type {LocalizedString} */ (`Cancelada`);
	return /** @type {LocalizedString} */ (`${i?.status}`)
	
};

/**
* | status | output |
* | --- | --- |
* | "todo" | "To do" |
* | "in_progress" | "In progress" |
* | "waiting" | "Waiting" |
* | "done" | "Done" |
* | "canceled" | "Canceled" |
* | * | "{status}" |
*
* @param {Task_Status_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_status_label = /** @type {((inputs: Task_Status_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Status_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_status_label(inputs)
	return pt_br2_task_status_label(inputs)
});